<script setup lang="ts">
import { ref, watch, computed, onMounted, markRaw } from "vue";
import { RouteRecordRaw, useRoute, useRouter } from "vue-router"
import { useLayouts, useUserStore, ExternalPage } from "@k-digitale/kappa";
import SelComp from './pages/SelComp.vue';

//IMPORT COMPOSABLES
import { useCesfUser, useViewStatus } from "@/composables"

const route = useRoute();
const router = useRouter();
const { appStarting, layouts } = useLayouts();

//COMPOSABLES
const { updateLocale } = useViewStatus();

const layout = computed(() => appStarting.value === true ? layouts['splash'] : layouts[route?.meta.layout as string || 'default'] )
const userStore = useUserStore();

onMounted(async () => {
    appStarting.value = true;
    updateLocale();
    try {
        await userStore.initUser();
    }
    finally {
        appStarting.value = false;
    }
})

watch(
    () => userStore.isLogged,
    (newValue, oldValue) => {
        if(oldValue === true && newValue === false) {
            router.push('/login');
        }
    }
);

watch(
    () => userStore.user,
    (newValue, oldValue) => {
        if(newValue != oldValue) {
            const { cesfUser } = useCesfUser();
            // **************************************************************************
            // rimozione route custom eventualmente presenti
            const alreadyPresentCustomRoutes = router.getRoutes().filter(r => r.meta["k"]);
            alreadyPresentCustomRoutes.forEach(r => router.removeRoute(r.name));
            // userStore.userRoutes = [];

            if(cesfUser.value && cesfUser.value.isExtranetSuperuser == true) {

                const customRoutes : any[] = [{
                    path: '/selcomp',
                    component: markRaw(SelComp),
                    meta: {
                        requiresAuth: true,
                        menu: {
                            label: 'CAMBIO AZIENDA',
                            icon: 'pi pi-cog'
                        }
                    }
                }];


                // **************************************************************************
                // aggiunta route custom

                customRoutes.forEach(route => {
                    route.meta["k"] = "k";
                    if(!route.name || route.name.toString().length <= 0) {
                        route.name = "r_" + route.path;
                    };

                    if(router.hasRoute(route.name)) {
                        console.warn(`[kappa] Route with name ${route.name.toString()} already present in current router!`);
                    }
                    else {
                        router.addRoute(route);
                    }
                });

                // userStore.userRoutes.push(...customRoutes);
            }
        }
    }
);

</script>

<template>
    <ConfirmDialog></ConfirmDialog>
    <Toast></Toast>

    <component :is="layout" />
    <!-- <transition name="fade" mode="out-in">
        <component :is="layout" />
    </transition> -->
</template>

<style>
.p-toast.p-toast-topright {
    z-index: 1000;
    top: 70px;
}

/* .fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
} */

</style>